import { Inject, Injectable } from '@angular/core';
import { Observable, of, iif, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { GeneratorEnv, GENERATOR_ENV_TOKEN } from '../../generator-env-token';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { CmsModule } from '../entity/cms-module';

@Injectable({
  providedIn: 'root'
})
export class CmsService {

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) private generatorEnv: GeneratorEnv,
    private http: CommonHttpClientService
  ) { }

  get<T>(cmsType: string, params?: { [param: string]: string | string[]; }): Observable<T> {
    return this.http.get<T>(`${this.generatorEnv.apiHost}/api/cms/${cmsType}`, { params });
  }

  getDetail<T>(cmsType: string, id: number): Observable<T> {
    return this.http.get<T>(`${this.generatorEnv.apiHost}/api/cms/${cmsType}/${id}`);
  }

  getNormalDetail<T>(lang: string, cmsType: string, id: number): Observable<T> {
    return this.http.get<T>(`${this.generatorEnv.apiHost}/api/${lang}/cm/normal/${cmsType}/${id}`);
  }

  getMenuSetting(cmsType: string): Observable<any> {
    return timer(0, 0).pipe(take(1))
    // TODO 沒有menuSetting
    return this.http.get<any>(`${this.generatorEnv.apiHost}/api/cms/menuSetting/${cmsType}`);
  }

  resolveCmsType(lang: string,cmsType: string): Observable<CmsModule> {
    return this.http.get<CmsModule>(`${this.generatorEnv.apiHost}/api/site/${lang}/menu/${cmsType}`);
  }
}
